<template>
  <div id="TOSForm">
    <!-- Agreement -->
    <div class="card">
      <!-- Title -->
      <div class="card-title">Terms of Service and Privacy Policy</div>

      <!-- content -->
      <div class="content-wrapper" ref="outerTOS">
        <div class="content-window">
          <TOSHtml />
        </div>
      </div>

      <!-- Check radio -->
      <div class="check-button" :class="{ enabled: enabled }" @click="agree" @keypress.enter="agree">
        <div class="check-radio">
          <inline-svg v-if="agreed" :src="$assets.svg['complete-icon']" width="100%" height="100%" fill="#76BC21" />
        </div>
        <div class="button-msg">
          Check here to indicate that you have READ AND AGREE to the Terms of Service and its Cookie &amp; Privacy
          Policy agreement above
        </div>
      </div>

      <div class="error-msg" v-if="ShowErrorMsg">Please check our agreement button to create you account</div>
    </div>

    <!-- Register button -->
    <button
      type="button"
      :class="{
        'create-account-btn': true,
        'btn-active': agreed,
      }"
      @click="createAccount"
    >
      Create Account and Continue
    </button>

    <HUBLoader v-if="submitting" />
  </div>
</template>

<script>
import TOSHtml from './TOSHtml.vue';

import HUBLoader from '@/components/common/hubLoading.vue';

export default {
  components: {
    TOSHtml,
    HUBLoader,
  },
  props: {
    clientData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      agreed: false,
      ShowErrorMsg: false,
      enabled: false,
      submitting: false,
    };
  },

  mounted() {
    window.scrollTo({ top: 0 });
    this.$refs.outerTOS.addEventListener('scroll', this.onScroll);
  },

  methods: {
    onScroll() {
      if (this.enabled) {
        this.$refs.outerTOS.removeEventListener('scroll', this.onScroll);
        return;
      }

      const sh = this.$refs.outerTOS.scrollHeight;
      const st = this.$refs.outerTOS.scrollTop;
      const ht = this.$refs.outerTOS.offsetHeight;

      this.enabled = ht === 0 || Math.ceil(st) + ht >= sh;
    },

    agree() {
      this.agreed = !this.agreed;

      if (this.agreed) {
        this.ShowErrorMsg = false;
      }
    },

    createAccount() {
      if (!this.agreed) {
        this.ShowErrorMsg = true;
        // console.log('ERROR - could not submit registration');
        return;
      }

      this.ShowErrorMsg = false;
      this.submitRegistrationForm();
    },

    async submitRegistrationForm() {
      const postClientData = {
        firstName: this.clientData.firstName.trim(),
        lastName: this.clientData.lastName.trim(),
        phoneNumber: this.clientData.phoneNumber.trim(),
        email: this.clientData.email.trim(),
        password: this.clientData.password,
        agencyId: this.clientData.agencyId,
        newAgencyName: this.clientData.newAgencyName.trim(),
        provinceId: this.clientData.provinceId,
        address: this.clientData.address.trim(),
        cityId: this.clientData.cityId,
        postcode: this.clientData.postcode.trim(),
      };

      if (postClientData.agencyId === -1) {
        postClientData.agencyId = 0;
      }

      this.submitting = true;
      await this.$api.post('/facilitators', postClientData);
      this.submitting = false;
      this.$emit('onSubmitted');
    },
  },
};
</script>

<style scoped>
#TOSForm {
  display: flex;
  flex-direction: column;
  align-items: center;

  box-sizing: border-box;
  width: 100%;
  padding: 2em 1em;
}

.card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  box-sizing: border-box;
  width: 100%;

  border: 1px solid black;
  border-radius: 1em;
  box-shadow: 0 0 10px 1px rgb(0 0 0 / 50%);
  padding: 2em 1.5em;
  background: #fff;
  color: #818285;
}

.card-title {
  margin-bottom: 1em;
  width: 100%;
  font-size: 1.2em;
  font-weight: 700;
  text-align: center;
}

/** Agreement box */
.content-wrapper {
  flex: 1;
}
.content-window {
  box-sizing: border-box;
  width: 100%;
  padding: 1em 1.5em;
}

/** Agreement Check */
.check-button {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 1em;
  cursor: pointer;
}

.check-button .check-radio {
  border: 1px solid #aaa;
  border-radius: 50%;
  background: #fff;
  height: 1.4em;
  width: 1.4em;
}

.check-button .button-msg {
  flex: 1;
  margin-left: 1em;
}

.error-msg {
  margin: 1em 1em 0;
  width: 100%;
  color: rgb(136, 0, 0);
  font-size: 1em;
}

/** Create button */
.create-account-btn {
  margin-top: 2em;
  border: 2px solid white;
  border-radius: 0.5em;
  padding: 0.8em 3em;
  background-color: rgba(255, 255, 255, 0);
  color: white;
  font-size: 1em;
  font-weight: 400;
}
.btn-active {
  border-color: transparent;
  background-color: white;
  color: rgb(59, 59, 59);
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.75);
  cursor: pointer;
}

/* overwrite browser settings to make sure scroll bar is visible when it's needed */
/* only chrome-derivative browsers (webkit) supported for now */
::-webkit-scrollbar {
  -webkit-appearance: none;
  border-radius: 0.3em;
  width: 0.6em;
  background: rgba(255, 255, 255, 0);
}
::-webkit-scrollbar-thumb {
  border-radius: 0.3em;
  background: rgba(0, 0, 0, 0.5);
  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

/** Landscape mobile */
@media only screen and (orientation: landscape) and (max-height: 600px) {
  #TOSForm {
    padding: 2em 0;
  }

  .card {
    padding: 2em;
  }
}

/** Larger devices */
@media only screen and (min-width: 601px) and (min-height: 601px) {
  #TOSForm {
    height: 100%;
  }

  .card {
    height: calc(100% - 5em);
    padding: 3em;
  }

  .card-title {
    margin-bottom: 2em;
  }

  .content-wrapper {
    margin-left: 0.6em;
    width: calc(100% + 7em);
    overflow-y: scroll;
  }
  .content-window {
    padding: 1em 3em;
  }

  .check-button {
    margin-top: 2em;
    cursor: default;
    pointer-events: none;
  }
  .check-button.enabled {
    cursor: pointer;
    pointer-events: unset;
  }
  .check-button .check-radio {
    border: 1px solid #ccc;
  }
  .check-button.enabled .check-radio {
    border: 1px solid #aaa;
  }
  .check-button .button-msg {
    color: #ccc;
  }
  .check-button.enabled .button-msg {
    color: unset;
  }
}
</style>
